<div class="container">
  <ca-edit-profile [profile]="profile | async"
    (save)="save($event)"></ca-edit-profile>
</div>